import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import VuexPersistence from "vuex-persist";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth
  },
  plugins: [new VuexPersistence().plugin]
});
